// VideoGrid.tsx
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Modal,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useState } from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import "./Video.scss";
import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useAppDispatch, useAppSelector } from "../../Redux/Store/Hooks";
import { useNavigate } from "react-router-dom";
import { clearListuser, listUser } from "../../Redux/Slices/User/ListUserSlice";
import {
  clearListVideoTutorials,
  listVideoTutorials,
} from "../../Redux/Slices/VideoTutorials/ListVideoTutorialsSlice";
import Menus from "../../Components/Menu/Menu";
import IconButtonField from "../../Components/Button/IconButtonField";
import Avatars from "../../Components/Avatar/Avatars";
import { clearLoginStatus } from "../../Redux/Slices/LoginSlicer/LoginSlicer";
import { clearDashboardChart } from "../../Redux/Slices/DashboardChart/DashboardChart";
import { IVideoTutorial } from "./IVideoTutorial";
import UserProfileSection from "../../Components/UserProfileSection/UserProfileSection";

const VideoGrid: React.FC = () => {
  const isUCAT =
    window.location.hostname.split(".")[0]?.includes("ucat") ||
    window.location.hostname.split(".")[0] === "192";

  const [openvideo, setOpenvideo] = useState(false);

  const handleOpen = (index: number) => {
    setCurrentIndex(index); // set the video to play
    setOpenvideo(true); // open modal
  };
  const handleClosevideo = () => setOpenvideo(false);

  const dispatch = useAppDispatch();
  const nav = useNavigate();

  // Domain determination
  const hostname = window.location.hostname;
  let domain = "test"; // default for 192/127
  if (hostname.includes("ucat")) {
    domain = "ucat";
  } else if (hostname.includes("learn")) {
    domain = "learn";
  }

  const [value, setValue] = React.useState("1");
  const [searchTerm, setSearchTerm] = useState("");

  const categoryMap: any = {
    "1": "", // All
    "2": "GATE Walkthrough",
    "3": "Short Lessons",
    "4": "Student Picks",
  };

  React.useEffect(() => {
    dispatch(listUser());
  }, [dispatch]);

  React.useEffect(() => {
    const filters: any = { domain, show_in_dashboard_only: false };
    // if (value !== "1") {
    //   filters.category_name = categoryMap[value]; // Assuming API might support category name or ID
    // }
    // Since the user asked to send filters to the API:
    dispatch(listVideoTutorials(filters));
  }, [dispatch, domain, value]);

  const { data: videoTutorialsData, isLoading: isVideosLoading } =
    useAppSelector((state) => state.ListVideoTutorialsSlice);

  const videoList: IVideoTutorial[] = Array.isArray(videoTutorialsData?.data)
    ? (videoTutorialsData?.data as IVideoTutorial[])
    : (videoTutorialsData?.data?.video_tutorials || []);

  const [currentIndex, setCurrentIndex] = useState(0);
  const currentVideo = videoList[currentIndex];

  const handleNextvideo = () => {
    setCurrentIndex((prev) => (prev + 1) % videoList.length);
  };

  const handlePrevideo = () => {
    setCurrentIndex((prev) => (prev - 1 + videoList.length) % videoList.length);
  };

  const handleVideoSelect = (index: number) => {
    setCurrentIndex(index);
  };
  const extractVideoId = (url: string) => {
    if (!url) return "";
    const match = url.match(
      /(?:youtu\.be\/|youtube\.com\/(?:embed\/|watch\?v=))([\w-]+)/
    );
    return match ? match[1] : "";
  };

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const filteredVideos = videoList.filter((video) => {
    const matchesSearch =
      video.category_info?.meta_value
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||
      video.description?.toLowerCase().includes(searchTerm.toLowerCase());

    // We still keep a light client-side filter for tabs if the API returns everything,
    // or if we want to search within the current domain/category.
    const matchesCategory =
      value === "1" || video.category_info?.meta_value === categoryMap[value];

    return matchesSearch && matchesCategory;
  });

  const { data: ListUserSliceLoading } = useAppSelector(
    (state) => state.ListUserSlice
  );
  const ListUser: any = Array.isArray(ListUserSliceLoading?.data)
    ? ListUserSliceLoading?.data.map((user, index) => ({
      ...user,
      index: index + 1,
    }))
    : [];
  return (
    <div className="ViedoStudentAlingment">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <div className="DashboardStudent" style={{ fontWeight: "700" }}>
            Video Tutorials
          </div>
          <div className="StudentPractice" style={{ fontSize: "14px" }}>
            Explore walkthroughs, teaching clips, and revision tips.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
          }}
        >
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Search videos..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
            }}
            sx={{
              borderRadius: "8px",
              width: "25%",
              backgroundColor: "#fff",
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          />{" "}
          <UserProfileSection />
        </div>
      </div>

      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleChange}
              sx={{
                "& .MuiTab-root": {
                  "&.Mui-selected": {
                    background: "none !important",
                    color: "#009dff !important",
                  },
                },
                "& .MuiTabs-indicator": {
                  margin: "9px 0px",
                },
              }}
              aria-label="lab API tabs example"
            >
              <Tab
                label="All"
                value="1"
                sx={{ textTransform: "capitalize", fontSize: "14px" }}
              />
              <Tab
                label={isUCAT ? "UCAT Walkthroughs" : "GATE Walkthroughs"}
                value="2"
                sx={{ textTransform: "capitalize", fontSize: "14px" }}
              />
              <Tab
                label="Short Lessons"
                value="3"
                sx={{ textTransform: "capitalize", fontSize: "14px" }}
              />
              <Tab
                label="Student Picks"
                value="4"
                sx={{ textTransform: "capitalize", fontSize: "14px" }}
              />
            </TabList>
          </Box>
          <TabPanel sx={{ padding: "24px 0px" }} value={value}>
            <Grid container spacing={3}>
              {filteredVideos.length > 0 ? (
                filteredVideos.map((video, index) => (
                  <Grid key={video.vid_tut_id} item xs={12} sm={12} md={6} lg={3}>
                    <Box
                      sx={{
                        boxShadow: "0 0px 5px rgba(0, 0, 0, 0.1)",
                        borderRadius: "10px",
                        transition: "transform 0.2s, box-shadow 0.2s",
                        "&:hover": {
                          boxShadow: "0 4px 4px rgba(0,0,0,0.18)",
                        },
                      }}
                    >
                      <Card
                        sx={{
                          cursor: "pointer",
                          borderRadius: "10px 10px 0px 0px",
                        }}
                        onClick={() => handleOpen(index)}
                      >
                        <Box sx={{ position: "relative", paddingTop: "56.25%" }}>
                          <CardMedia
                            component="img"
                            image={`https://img.youtube.com/vi/${extractVideoId(
                              video.video_url
                            )}/0.jpg`}
                            alt={video.category_info?.meta_value}
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <Box
                            sx={{
                              position: "absolute",
                              bottom: 8,
                              right: 8,
                              background: "#000000BF",
                              color: "white",
                              padding: "2px 6px",
                              borderRadius: "4px",
                              fontSize: "12px",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <AccessTimeIcon />
                            {/* <span>{video.time}</span> */}
                            <span>Video</span>
                          </Box>
                        </Box>
                      </Card>
                      <Typography
                        variant="body1"
                        fontWeight="bold"
                        className="viedotitle"
                      >
                        {video.category_info?.meta_value}
                      </Typography>
                    </Box>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <div
                    style={{
                      color: "#6b7280",
                      padding: "4rem",
                      fontSize: "16px",
                      textAlign: "center",
                    }}
                  >
                    No videos found matching your criteria.
                  </div>
                </Grid>
              )}
            </Grid>
          </TabPanel>
          {" "}
        </TabContext>
      </Box>

      <Modal open={openvideo}>
        {/* Video Area with Previews */}
        <>
          <Box sx={{ width: "100%", position: "relative" }}>
            <IconButton
              sx={{
                position: "absolute",
                top: 6,
                right: 38,
                m: 1, // optional: adds margin from edges
                color: "#FFFFFF",
                zIndex: 2,
                backgroundColor: "gray",
              }}
              onClick={handleClosevideo}
            >
              <CloseIcon
                sx={{ fontSize: "20px", color: "white", fontWeight: 600 }}
              />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              width: "100%",
              height: "100%",
              mb: 2,
            }}
          >
            {/* Left Preview + Arrow */}
            <Box sx={{ width: "10%", position: "relative" }}>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translateY(-50%)",
                  color: "#FFFFFF",
                  zIndex: 2,
                }}
                onClick={handlePrevideo}
              >
                <ArrowBackIosNewIcon sx={{ fontSize: "50px" }} />
              </IconButton>
            </Box>

            {/* Center Main Video */}
            <Box sx={{ width: "80%", height: "85vh", display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
              {isVideosLoading ? (
                <CircularProgress size={60} sx={{ color: "white" }} />
              ) : currentVideo ? (
                <Box
                  component="iframe"
                  width="100%"
                  height="100%"
                  src={`${currentVideo?.video_url}?autoplay=1`}
                  title={currentVideo?.category_info?.meta_value}
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  sx={{ borderRadius: "20px" }}
                />
              ) : (
                <Typography variant="h6" color="white">No video selected</Typography>
              )}
            </Box>

            {/* Right Preview + Arrow */}
            <Box sx={{ width: "10%", position: "relative" }}>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#FFFFFF",
                  zIndex: 2,
                }}
                onClick={handleNextvideo}
              >
                <ArrowForwardIosIcon sx={{ fontSize: "50px" }} />
              </IconButton>
            </Box>
          </Box>
        </>
      </Modal>
    </div>
  );
};

export default VideoGrid;
